import type { DistributedOmit } from 'type-fest'
import { MessageToEmbed, MessageToIframe } from '../../../shared/types'

const getEmbedOrigin = () => {
  const embedOrigin = new URLSearchParams(window.location.search).get('embedOrigin')
  if (!embedOrigin) {
    throw Error(`No embedOrigin specified in query string`)
  }
  return embedOrigin
}

export const getWorkspaceId = () => {
  const workspaceId = new URLSearchParams(window.location.search).get('workspaceId')
  if (!workspaceId) {
    throw Error(`No workspaceId specified in query string`)
  }
  return workspaceId
}

export const getTenantId = () => {
  const tenantId = new URLSearchParams(window.location.search).get('tenantId')
  if (!tenantId) {
    throw Error(`No tenantId specified in query string`)
  }
  return tenantId
}

export const getPlaybookId = () => {
  const playbookId = new URLSearchParams(window.location.search).get('playbookId')
  if (!playbookId) {
    return undefined
  }
  return playbookId
}

export const sendMessageToEmbed = (message: DistributedOmit<MessageToEmbed, 'source'>) => {
  const composedMessage: MessageToEmbed = { ...message, source: 'chili-chat-iframe' }
  window.parent.postMessage(composedMessage, getEmbedOrigin())
}

export const createEmbedMessageListener = (callback: (message: MessageToIframe) => void) => {
  const listener = (message: MessageEvent<unknown>) => {
    const data = validataMessageFormat(message.data)
    if (message.origin !== getEmbedOrigin() || !data) {
      return
    }
    callback(data)
  }
  window.addEventListener('message', listener)
  return () => window.removeEventListener('message', listener)
}

const validataMessageFormat = (data: unknown): MessageToIframe | undefined => {
  const isValidFormat = typeof data === 'object' && data
  if (!isValidFormat) {
    return
  }
  const isValidSource = 'source' in data && data.source === 'chili-chat-embed'
  if (!isValidSource) {
    return
  }
  return data as MessageToIframe
}
